/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const EmptyPage = styled.div`
  height: 400px;
  display: grid;
  place-items: center;
  color: ${Palette.PrimaryGray._700};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  background: ${Palette.PrimaryGray._000};
`;

export const ItemsContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  height: 400px;
  padding: 24px;
  background: ${Palette.PrimaryGray._000};
  ::-webkit-scrollbar {
    width: 6px;
    background-color: ${Palette.PrimaryGray._000};
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;
